import React from 'react';
import { Route } from 'react-router-dom';
import CommentPageRoute from './CommentPageRoute';

const basePath = '/v2/comment';

export default (
  <Route path={`${basePath}/:commentId`}>
    <CommentPageRoute />
  </Route>
);
